import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/aiot_logo.png';
import _imports_1 from '@/assets/logo/aiot_logo2.png';
import _imports_2 from '@/assets/aiot_bg1.png';
import _imports_3 from '@/assets/aiot_bg2.png';
import _imports_4 from '@/assets/aiot_bg3.png';
import _imports_5 from '@/assets/aiot_block2.png';
import _imports_6 from '@/assets/aiot_block3.png';
import _imports_7 from '@/assets/aiot_block5.png';
const _withScopeId = n => (_pushScopeId("data-v-e7ba4e24"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "fs-s"
};
const _hoisted_2 = {
  class: "block block1"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-box d-flex jc-between main-width"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "text-white"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "logotitle fs-x fw-b"
}, "第九届中国研究生智慧城市技术与创意设计大赛"), /*#__PURE__*/_createElementVNode("div", {
  class: "title pt-10 pb-20 fs-xl"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "fw-b"
}, "未来城市美学赛道")])]), /*#__PURE__*/_createElementVNode("div", {
  class: "imgs-box d-flex pt-10"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "aiot_logo",
  src: _imports_0
}), /*#__PURE__*/_createElementVNode("div", {
  class: "img_box"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "aiot_logo",
  src: _imports_1
})])])], -1));
const _hoisted_4 = {
  class: "main-width d-flex unit_list text-white"
};
const _hoisted_5 = {
  class: "fw-b"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "aiot_bg1"
}, null, -1));
const _hoisted_7 = {
  class: "block block1 bg_3"
};
const _hoisted_8 = {
  class: "main-width main_box text-white"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title_2_box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "fs-xl fw-b title_2"
}, "未来城市美学赛道")], -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fw-b text_des1"
}, "发掘优秀人才、展示数智成果、提升创作水平", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fs-l pt-10 text_des2"
}, "集技术创新、文化创意、价值创造于一体的竞赛活动", -1));
const _hoisted_12 = {
  class: "fs-l pt-40 text_des3 pb-20"
};
const _hoisted_13 = {
  class: "fs-l text_des3 pb-20"
};
const _hoisted_14 = {
  class: "fs-l text_des3 pb-20"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "aiot_bg1"
}, null, -1));
const _hoisted_16 = {
  class: "block block1 bg_3 bg_4"
};
const _hoisted_17 = {
  class: "main-width main_box text-white"
};
const _hoisted_18 = {
  class: "d-flex ai-center"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "img_box pt-6"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "aiot_logo",
  src: _imports_1
})], -1));
const _hoisted_20 = ["innerHTML"];
const _hoisted_21 = {
  class: "pt-40"
};
const _hoisted_22 = ["innerHTML"];
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "aiot_bg1"
}, null, -1));
const _hoisted_24 = {
  class: "block block2"
};
const _hoisted_25 = {
  class: "main-width d-flex ai-center jc-between content_box"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fs-l title fw-b"
}, "了解参赛指南、报名加入赛道", -1));
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "subtitle fs-m pt-10 pb-20 text-gray"
}, "大鹏一日同风起，扶摇直上九万里！", -1));
const _hoisted_28 = {
  class: "fs-m pb-20 pr-100 des"
};
const _hoisted_29 = {
  class: "d-flex jc-between pr-100"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  width: "400"
}, null, -1));
const _hoisted_31 = {
  class: "block block3 bg-bggray"
};
const _hoisted_32 = {
  class: "main-width d-flex jc-between ai-center content_box"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title fs-l fw-b"
}, "参加赛前培训、快速提升竞赛能力", -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "subtitle pt-10 pb-20 fs-m"
}, "纸上得来终觉浅，绝知此事要躬行！", -1));
const _hoisted_35 = {
  class: "text-white fs-m pb-20 pr-100 des"
};
const _hoisted_36 = {
  class: "text-white fs-m pb-20 pr-100 des"
};
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fw-b"
}, "“AIoT创新赋能体系”", -1));
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  width: "400"
}, null, -1));
const _hoisted_39 = {
  class: "block block5"
};
const _hoisted_40 = {
  class: "main-width main_box d-flex jc-between ai-center"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title fs-l fw-b"
}, "开展创作活动、积极参与展示交流", -1));
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "subtitle pt-10 pb-20 fs-m text-gray"
}, "宝剑锋从磨砺出、吹尽黄沙始到金！", -1));
const _hoisted_43 = {
  class: "d-flex jc-between pt-20"
};
const _hoisted_44 = {
  class: "text-box"
};
const _hoisted_45 = {
  class: "fs-m pb-20 pr-100 des"
};
const _hoisted_46 = {
  class: "fs-m pb-20 pr-100 des"
};
const _hoisted_47 = {
  class: "fs-m pb-20 pr-100 des"
};
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7
}, null, -1));
import { Select, Right } from '@element-plus/icons-vue';
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import wx from 'weixin-js-sdk';
import axios from 'axios';
export default {
  __name: 'Aiot',
  setup(__props) {
    const router = useRouter();
    const store = useStore();
    const textData = {
      block1: '未来城市美学赛道',
      block1_1: '加入未来城市美学赛道<br>争当未来产业领军人物',
      block2_0: '城市是人类文明发展的重要标志。',
      block2_1: '一方面，如何减少人类发展行为对环境的负面影响、让绿色和发展不再矛盾，已成为城市可持续发展的必答题；另一方面，构建数字孪生型美学系统，基于有限物理资源创造无限数字空间，以承载人类日益增长的美学需求和发展愿望，正在成为未来城市建设的高分题。',
      block2_2: 'AIoT碳手印技术以其反映各类活动对环境正面影响的数智化特性，正在为解答这两项重大课题拓展新路径、开创新天地。',
      block3: '为帮助各参赛队伍在竞赛中取得更好成绩，赛道组委会安排了系列赛前培训活动，主要包含集训、考察和实践三个模块内容。',
      block3_0: '赛道组委会精心组织赛前培训活动，通过实地考察、调研与课堂教学相结合的方式，让参赛团队以场景化、项目化、成果化的方式学习优秀AIoT碳手印案例，夯实基础能力，进一步拓宽知识面。',
      block5: '赛道组委会与国际碳手印组织合作建立的创新培育模式（“产学研用赛评”六位一体、“政校商用”四维耦合）已得到业界领导者、专家及高校师生的广泛认可与支持。',
      block5_0: '赛道组委会鼓励参赛团队采用“科技+文创”的创作手法，结合具体项目素材，深度挖掘潜在价值，督促学员以反复打磨、精耕细作的方式产出精品佳作；赛事期间，组委会将举办多种形式的展示交流活动，通过促进赛事各方的深度沟通，搭建有利于各方长期合作、学习成长的高价值平台。',
      block5_1: '人才兴则产业强！赛道组委会与高校共建“AIoT创新实践基地”，与用户单位共创“AIoT创新示范项目”，持续集聚资源、积累能力，以产业链精准布局人才链，依托人才链壮大产业链， 致力于成就一批AIoT领军人物，打造“良将如潮、人才辈出”的活跃生态！'
    };
    const unitList = store.state.VUEX_ISMOBILE ? [{
      title: '大赛指导单位',
      list: ['教育部学位管理与研究生教育司']
    }, {
      title: '大赛主办单位',
      list: ['中国学位与研究生教育学会', '中国科协青少年科技中心']
    }, {
      title: '大赛联合主办单位',
      list: ['中关村智慧城市产业技术创新战略联盟']
    }, {
      title: '大赛支持单位',
      list: ['中共杭州市委人才办', '杭州市经济与信息化局']
    }, {
      title: '大赛承办单位',
      list: ['浙大城市学院', '国科大杭州高等研究院']
    }, {
      title: '大赛联合承办单位',
      list: ['浙大城市学院滨江创新中心', '浙大城市学院校友基金会']
    }, {
      title: '赛道承办单位',
      list: ['北京澳新教育科技有限公司', '星米建筑数字化(杭州)有限公司']
    }, {
      title: '赛道协办单位',
      list: ['国际碳手印组织AIoT创新赋能中心', '深圳箩筐技术有限公司']
    }] : [{
      title: '大赛指导单位',
      list: ['教育部学位管理与研究生教育司']
    }, {
      title: '大赛主办单位',
      list: ['中国学位与研究生教育学会', '中国科协青少年科技中心']
    }, {
      title: '大赛联合主办单位',
      list: ['中关村智慧城市产业技术创新战略联盟']
    }, {
      title: '赛道承办单位',
      list: ['北京澳新教育科技有限公司', '星米建筑数字化(杭州)有限公司']
    }, {
      title: '大赛承办单位',
      list: ['浙大城市学院', '国科大杭州高等研究院']
    }, {
      title: '大赛联合承办单位',
      list: ['浙大城市学院滨江创新中心', '浙大城市学院校友基金会']
    }, {
      title: '大赛支持单位',
      list: ['中共杭州市委人才办', '杭州市经济与信息化局']
    }, {
      title: '赛道协办单位',
      list: ['国际碳手印组织AIoT创新赋能中心', '深圳箩筐技术有限公司']
    }];
    const reportList = [{
      title: '灵境高校元宇宙：高品质数字交互式社交空间解决方案',
      subtitle: '灵境高校元宇宙',
      content: '灵境星球 —— 北京航空航天大学'
    }, {
      title: '智慧城市灭火——智能分布式“低碳”自识别水动力飞行灭火系统',
      subtitle: '智慧城市灭火',
      content: 'SCUAA飞跃地平线 —— 四川大学'
    }, {
      title: '坝道卫士-复杂地质环境堤坝防洪智能治理解决方案供应商',
      subtitle: '坝道卫士',
      content: '坝道卫士 —— 东华理工大学'
    }];
    const signupList = [{
      title: '① 报名成功，由赛道执委会组织系列参观、考察和培训活动',
      content: ''
    }, {
      title: '② 经赛道执委会授权老师认可，可获得参赛队伍推荐码',
      content: ''
    }, {
      title: '③ 各参赛队伍按赛道培训会要求，结合创作素材，开展创作活动',
      content: ''
    }, {
      title: '④ 参赛队伍需对所填信息的准确性和真实性负责',
      content: ''
    }];
    const loopList = [{
      content: '● &nbsp;报名成功即可获得赛前培训资格！',
      color: '#5aa8f0'
    }, {
      content: '● &nbsp;名师授课+专家讲座+企业高管创新实践辅导！',
      color: '#ed7d31'
    }, {
      content: '● &nbsp;获奖参赛队伍可获得头部企业就业机会！',
      color: '#dddddd'
    }, {
      content: '● &nbsp;获奖项目可获得专业机构投资！',
      color: '#dddddd'
    }, {
      content: '● &nbsp;获奖参赛队伍成员可享受杭州市D类E类人才待遇！',
      color: '#3cdba6'
    }, {
      content: '● &nbsp;完成培训课程可参加“一试双证”人才认定活动(人社部颁证）！',
      color: '#34d0f0'
    }];
    const toApplyPage = url => {
      location.href = url;
    };
    const toPage = url => {
      router.push({
        path: url
      });
    };
    const wxFunc = () => {
      const params = store.state.VUEX_SHARECONFIG.aiot;
      wx.ready(function () {
        //需在用户可能点击分享按钮前就先调用
        wx.updateAppMessageShareData({
          ...params,
          success: function () {}
        });
      });
    };
    onMounted(() => {
      wxFunc();
    });
    return (_ctx, _cache) => {
      const _component_el_carousel_item = _resolveComponent("el-carousel-item");
      const _component_el_carousel = _resolveComponent("el-carousel");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_carousel, {
        height: "100vh",
        "pause-on-hover": false,
        interval: "15000"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_carousel_item, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(unitList), (item, idx) => {
            return _openBlock(), _createElementBlock("div", {
              class: "unit_list_item pt-10",
              key: idx
            }, [_createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (cItem, cIdx) => {
              return _openBlock(), _createElementBlock("div", {
                class: "fs-x unit_list_item_content",
                key: cIdx
              }, _toDisplayString(cItem), 1);
            }), 128))]);
          }), 128))]), _hoisted_6])]),
          _: 1
        }), _createVNode(_component_el_carousel_item, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _hoisted_10, _hoisted_11, _createElementVNode("div", _hoisted_12, _toDisplayString(textData.block2_0), 1), _createElementVNode("div", _hoisted_13, _toDisplayString(textData.block2_1), 1), _createElementVNode("div", _hoisted_14, _toDisplayString(textData.block2_2), 1)]), _hoisted_15])]),
          _: 1
        }), _createVNode(_component_el_carousel_item, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", {
            class: "fw-b text_des1 text_green",
            innerHTML: textData.block1_1
          }, null, 8, _hoisted_20)]), _createElementVNode("div", _hoisted_21, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(loopList, (item, idx) => {
            return _createElementVNode("div", {
              class: "pb-10 d-flex ai-center",
              key: idx
            }, [_createElementVNode("div", {
              class: "pl-5 fs-l item_des",
              innerHTML: item.content
            }, null, 8, _hoisted_22)]);
          }), 64))])]), _hoisted_23])]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", null, [_hoisted_26, _hoisted_27, _createElementVNode("div", _hoisted_28, [_createTextVNode("为便于各意向参赛队伍了解情况，赛道组委会组织编制了"), _createElementVNode("span", {
        style: {
          "color": "#327db9",
          "cursor": "pointer",
          "text-decoration": "underline"
        },
        onClick: _cache[0] || (_cache[0] = $event => toPage('/pdf/AIoT_zhinan'))
      }, "《未来城市美学赛道参赛指南》"), _createTextVNode("。指南包含四章节内容：第一章赛道简介、第二章活动流程、第三章参赛注意事项和第四章附件。指南附件内容有AIoT碳手印标准简介、AIoT创新赋能中心简介、项目简表（模板）、项目说明书（模板）。 ")]), _createElementVNode("div", _hoisted_29, [_createVNode(_component_el_button, {
        class: "btn",
        color: "#327db9",
        dark: "",
        onClick: _cache[1] || (_cache[1] = $event => toApplyPage('https://f.wps.cn/g/39v6n5bZ/'))
      }, {
        default: _withCtx(() => [_createTextVNode("我要提交报名资料")]),
        _: 1
      })])]), _hoisted_30])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", null, [_hoisted_33, _hoisted_34, _createElementVNode("div", _hoisted_35, _toDisplayString(textData.block3), 1), _createElementVNode("div", _hoisted_36, _toDisplayString(textData.block3_0), 1), _createVNode(_component_el_button, {
        class: "btn",
        color: "#327db9",
        dark: "",
        onClick: _cache[2] || (_cache[2] = $event => toPage('/pdf/AIoT_funeng'))
      }, {
        default: _withCtx(() => [_createTextVNode("了解"), _hoisted_37]),
        _: 1
      })]), _hoisted_38])]), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createElementVNode("div", null, [_hoisted_41, _hoisted_42, _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, _toDisplayString(textData.block5), 1), _createElementVNode("div", _hoisted_46, _toDisplayString(textData.block5_0), 1), _createElementVNode("div", _hoisted_47, _toDisplayString(textData.block5_1), 1), _createVNode(_component_el_button, {
        class: "btn",
        color: "#327db9",
        dark: "",
        onClick: _cache[3] || (_cache[3] = $event => toApplyPage('https://f.wps.cn/g/byN4n30q/'))
      }, {
        default: _withCtx(() => [_createTextVNode("提交参赛作品")]),
        _: 1
      })])])]), _hoisted_48])])]);
    };
  }
};